import { render, staticRenderFns } from "./AddNewMultipleStudent.vue?vue&type=template&id=730701c6&"
import script from "./AddNewMultipleStudent.vue?vue&type=script&lang=js&"
export * from "./AddNewMultipleStudent.vue?vue&type=script&lang=js&"
import style0 from "./AddNewMultipleStudent.vue?vue&type=style&index=0&id=730701c6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports